import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '36px',
    background: 'white',
    overflowX: 'hidden',
    flex: 1,
    padding: '24px 0',
    '@media (max-width: 1024px)': {
      padding: '24px 0'
    },

    '& #editor': {
      outline: 0
    },

    '& img': {
      maxWidth: '100%'
    },

    '& details > summary > span ': {
      fontWeight: 'bold'
    },

    '& details ': {
      background: '#fcfcfc',
      border: '1px solid #eee',
      borderRadius: 10,
      marginBottom: 8
    },

    '& details > summary': {
      cursor: 'pointer',
      padding: '5px 5px 5px 20px',
      position: 'relative',
      listSyle: 'none',
      outline: 'none'
    },

    '& details > div': {
      padding: '0 5px 5px 20px'
    },

    '& #editor p': {
      fontSize: theme.size.base
    },

    '& #editor strong': {
      fontSize: theme.size.base
    },

    '& #editor ul': {
      paddingInlineStart: 20
    },

    '& #editor li': {
      fontSize: theme.size.base
    },

    '& .editor-container .toolbar': {
      padding: '0px 100px',
      '@media (max-width: 1024px)': {
        padding: '0px 48px'
      }
    },
    '& .editor-container .editor-input': {
      padding: '0px 100px',
      '@media (max-width: 1024px)': {
        padding: '0px 48px'
      }
    },
    '& .editor-container .editor-placeholder': {
      padding: '0px 100px',
      top: 4,
      left: 4,
      '@media (max-width: 1024px)': {
        padding: '0px 48px'
      }
    }
  },

  overview: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '60px',
    borderBottom: '1px solid #C6C6C6',
    boxSizing: 'border-box',
    width: '100%',
    minHeight: '100px',
    height: '100px',
    maxHeight: '100px',
    paddingLeft: '24px',
    background: '#F5F6F8',
    color: '#4A4A4A',

    '& > :not(:last-child)': {
      marginRight: '48px'
    }
  },

  overviewTitle: {
    fontSize: theme.size.xl
  },

  overviewStat: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',

    '& > :first-child': {
      marginBottom: '8px',
      fontSize: theme.size.xl
    },

    '& > :last-child': {
      fontSize: theme.size.base
    }
  },

  editorInfo: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '20px',
    padding: '0px 100px',
    '@media (max-width: 1024px)': {
      padding: '0px 48px'
    }
  },

  avatar: {
    marginRight: '8px',

    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },

  info: {
    display: 'flex',
    flexDirection: 'column'
  },

  infoLine: {
    fontSize: theme.size.base,
    color: '#8F8F8F',

    '& > span': {
      color: '#1F1F1F'
    },

    '&:first-child': {
      marginBottom: '7px'
    },

    // Around when titles written by and last updated tend to go offscreen
    [theme.breakpoints.down(400)]: {
      display: 'flex',
      flexDirection: 'column'
    }
  },

  metaSection: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '10px',
    minHeight: 31,
    padding: '0px 100px',
    '@media (max-width: 1024px)': {
      padding: '0px 48px'
    },

    // Around when titles written by and last updated tend to go offscreen
    [theme.breakpoints.down(400)]: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start'
    }
  },

  metaTitleBlock: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '16px',
    width: '80px',

    // Around when titles written by and last updated tend to go offscreen
    [theme.breakpoints.down(400)]: {
      marginBottom: '8px'
    }
  },

  icon: {
    marginRight: '8px'
  },

  removeTagIcon: {
    marginLeft: '4px',
    cursor: 'pointer'
  },

  muiIcon: {
    height: theme.size.base,
    width: theme.size.base
  },

  tagIcon: {
    height: theme.size.base,
    width: theme.size.base
  },

  folderIcon: {
    height: theme.size.base,
    width: theme.size.base,
    flexShrink: 0
  },

  metaTitle: {
    fontSize: theme.size.base,
    color: '#1F1F1F'
  },

  box: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #C6C6C6',
    boxSizing: 'border-box',
    borderRadius: '4px',
    padding: '4px 8px',
    background: '#F5F6F8',
    fontSize: theme.size.sm,
    color: '#8F8F8F'
  },

  defaultCursor: {
    cursor: 'default'
  },

  addTagBox: {
    cursor: 'pointer'
  },

  tagList: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    '& > div': {
      marginTop: 2,
      marginBottom: 2
    },
    '& > :not(:last-child)': {
      marginRight: '8px'
    }
  },

  title: {
    marginBottom: '16px',
    fontSize: theme.size.xxl,
    color: '#4A4A4A',
    padding: '0px 100px',
    '@media (max-width: 1024px)': {
      padding: '0px 48px'
    }
  },

  subtitle: {
    marginBottom: '14px',
    fontSize: theme.size.xl,
    color: '#4A4A4A',
    padding: '0px 100px',
    '@media (max-width: 1024px)': {
      padding: '0px 48px'
    }
  },

  content: {
    fontSize: theme.size.base,
    color: '#4A4A4A',
    padding: '0px 100px',
    '@media (max-width: 1024px)': {
      padding: '0px 48px'
    },

    // Taken from the widget
    '& p': {
      marginTop: '0px',
      fontSize: theme.size.base
    },

    '& li': {
      fontSize: theme.size.base
    },

    '& ul': {
      paddingInlineStart: 20
    },

    '& a': {
      textDecoration: 'underline !important'
    },

    '& strong': {
      display: 'inline-block',
      marginTop: 20
    },

    '& a, & a:hover': {
      margin: 'inherit',
      padding: 'inherit',
      fontSize: 'inherit',
      color: 'inherit'
    }
  },

  documentTitle: {
    color: '#4A4A4A',
    width: '100%',
    border: 0,
    margin: '10px 0px 8px 0px',
    outline: 'none',
    fontSize: theme.size.xxl,
    borderBottom: '1px solid #C6C6C6',
    paddingRight: 55,
    paddingBottom: '0.5rem'
  },

  documentTitleWordCounter: {
    color: '#8F8F8F',
    right: 100,
    bottom: 17,
    position: 'absolute',
    fontSize: theme.size.lg,
    textAlign: 'right'
  },

  inputBlock: {
    position: 'relative',
    display: 'flex',
    marginBottom: '25px',
    padding: '0px 100px',
    '@media (max-width: 1024px)': {
      padding: '0px 48px'
    }
  },

  subTitleHolder: {
    position: 'relative',
    width: 'calc(100% - 50px)'
  },

  documentSubTitle: {
    position: 'relative',
    fontSize: theme.size.xl,
    border: 0,
    paddingBottom: '0.5rem',
    outline: 'none',
    color: '#4A4A4A',
    width: '100%',
    resize: 'none',
    borderBottom: '1px solid #C6C6C6',

    '&::-webkit-scrollbar': {
      width: 8
    },

    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.primary.main,
      borderRadius: 0
    }
  },

  documentSubTitleWordCounter: {
    color: '#8F8F8F',
    right: 100,
    bottom: 4,
    position: 'absolute',
    fontSize: theme.size.lg,
    textAlign: 'right',
    borderBottom: '1px solid #C6C6C6',
    paddingBottom: 6
  }
}))

export default useStyles
